export const homepageSeoContent = {
  heroTitle: "Kakobuy Spreadsheet — Discover the Best Finds, Products & Shopping Guides",
  heroSubtitle: "Access the latest Kakobuy Spreadsheet resources, product databases, comparison guides, and expert shopping insights. Find trending products faster with organized spreadsheet collections.",
  ctaPrimary: "Kakobuy Sheet",
  ctaSecondary: "Buy It Now",
  mainSiteUrl: "https://kaspreadsheet.com",
  trustBadges: [
    "Updated Product Resources",
    "Detailed Comparison Guides",
    "Safe Shopping Information",
    "Expert Research",
  ],
  whatIsTitle: "What Is Kakobuy Spreadsheet?",
  whatIsContent: "Kakobuy Spreadsheet is a meticulously organized product discovery database that helps online shoppers navigate the vast world of fashion, accessories, electronics, and lifestyle goods. Rather than scrolling through endless product listings, users access a structured spreadsheet containing curated finds, price comparisons, and direct purchase links—all neatly categorized for effortless browsing. This system transforms chaotic online shopping into a streamlined, intelligent experience where every item has been pre-vetted and organized by category, making it the go-to resource for savvy shoppers who value both efficiency and discovery.",
  whyTitle: "Why Thousands of Shoppers Rely on Kakobuy Spreadsheet",
  featureCards: [
    { title: "Fast Product Discovery", description: "Skip the endless scrolling. Find exactly what you need in seconds with organized categories and instant filtering across thousands of curated products.", icon: "ri-flashlight-line" },
    { title: "Organized Product Lists", description: "Every product is meticulously sorted into logical categories—Shoes, Hoodies, Jackets, Accessories, and more—so nothing gets lost in the shuffle.", icon: "ri-list-check-3" },
    { title: "Community-Driven Research", description: "Benefit from collective shopping intelligence. Products are sourced and validated by a community of experienced buyers who know quality.", icon: "ri-group-line" },
    { title: "Smarter Buying Decisions", description: "Compare options side by side, check availability, and make confident purchases backed by structured data instead of impulse scrolling.", icon: "ri-lightbulb-line" },
  ],
  comparisonTitle: "Spreadsheet Comparison Center",
  comparisonPlatforms: [
    { name: "Kakobuy Spreadsheet", quality: "Excellent", database: "Comprehensive", experience: "Superior", highlight: true },
    { name: "CSSBuy Spreadsheet", quality: "Very Good", database: "Extensive", experience: "Reliable", highlight: false },
    { name: "Superbuy Spreadsheet", quality: "Good", database: "Large", experience: "Solid", highlight: false },
    { name: "Oopbuy Spreadsheet", quality: "Good", database: "Growing", experience: "Developing", highlight: false },
  ],
  safetyTitle: "Shop with Confidence",
  safetyContent: "We believe in responsible shopping. Every link shared through our spreadsheet resources points to verified platforms. We encourage users to double-check product details, read reviews, and make informed decisions. Your security and satisfaction come first—always.",
  ctaFinalTitle: "Ready to Discover Your Next Find?",
  ctaFinalSubtitle: "Access the complete Kakobuy Spreadsheet and start exploring thousands of curated products today.",
  articlesSectionTitle: "Expert Guides & Resources",
  articlesSectionSubtitle: "Dive deeper into spreadsheet strategies, product discovery techniques, and smart shopping methodologies.",
  articles: [
    {
      slug: "kakobuy-spreadsheet-guide",
      title: "Complete Kakobuy Spreadsheet Guide 2026: Master Product Discovery & Smart Shopping",
      summary: "Everything you need to know about using Kakobuy Spreadsheet to find the best products, compare deals, and shop smarter. From beginner basics to advanced strategies.",
      readTime: "12 min read",
      category: "Guide",
    },
  ],
};

export const brandSectionContent = {
  label: "/ about the project",
  heading: "Kakobuy Finds is an independent resource hub dedicated to helping online shoppers discover, compare, and access the best product spreadsheets available. We curate, organize, and share the most reliable spreadsheet resources so you spend less time searching and more time finding exactly what you want.",
  communityLabel: "trusted by",
  communityText: "thousands of smart shoppers worldwide",
};

export const footerContent = {
  description: "Kakobuy Finds is the ultimate resource hub for Kakobuy Spreadsheet users. Discover curated product databases, comparison guides, and expert shopping insights—all in one place.",
  navColumns: [
    {
      title: "Spreadsheets",
      links: [
        { label: "Kakobuy Spreadsheet", href: "/" },
        { label: "CSSBuy Spreadsheet", href: "#" },
        { label: "Superbuy Spreadsheet", href: "#" },
        { label: "Oopbuy Spreadsheet", href: "#" },
      ],
    },
    {
      title: "Resources",
      links: [
        { label: "Complete Guide", href: "/kakobuy-spreadsheet-guide" },
        { label: "Product Finds", href: "#" },
        { label: "Safety Guide", href: "#" },
        { label: "All Guides", href: "#" },
      ],
    },
    {
      title: "Categories",
      links: [
        { label: "Shoes", href: "https://kaspreadsheet.com/category-911-Shoes.html" },
        { label: "Hoodies & Sweaters", href: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
        { label: "T-Shirts", href: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
        { label: "Jackets", href: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
      ],
    },
  ],
};